export default "__VITE_ASSET__D19iFYuH__"